import MemoryType from "../memory/enum/MemoryType";
import LocalStorageHandler from "../memory/handler/LocalStorageHandler";

const localStorage = new LocalStorageHandler();

export const performPostRequest = async (url, payload) => {
	const token = localStorage.read(MemoryType.TOKEN);		
	try {
		return await fetch(url, {
			method: "POST",
			headers: {
				"Content-type": "application/json",
				Authorization: token
			},
			body: payload,
		});
	} catch (error) {
		return new Error(error);
	}
};

export const performPostRequestWithToken = async (url, payload) => {
	const token = localStorage.read(MemoryType.TOKEN);
	try {
		return await fetch(url, {
			method: "POST",
			headers: {
				"Content-type": "application/json",
				Authorization: token,
			},
			body: payload,
		});
	} catch (error) {
		return new Error(error);
	}
};